import { render, staticRenderFns } from "./c_goods.vue?vue&type=template&id=0996cc9e&scoped=true"
import script from "./c_goods.vue?vue&type=script&lang=js"
export * from "./c_goods.vue?vue&type=script&lang=js"
import style0 from "./c_goods.vue?vue&type=style&index=0&id=0996cc9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996cc9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0996cc9e')) {
      api.createRecord('0996cc9e', component.options)
    } else {
      api.reload('0996cc9e', component.options)
    }
    module.hot.accept("./c_goods.vue?vue&type=template&id=0996cc9e&scoped=true", function () {
      api.rerender('0996cc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_goods.vue"
export default component.exports